import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import React from 'react'

const MemberWorkIdentifierTooltip = () => (
    <CustomToolTip
        type="?"
        info="When searching by 'Member Work Identifier' you are not able to add any other search criteria."
    />
)
export default MemberWorkIdentifierTooltip
